var map = {
	"./AccordianArrow.svg": 975,
	"./ArrowCircleUpRight": 544,
	"./ArrowCircleUpRight.js": 544,
	"./ArrowIcon": 545,
	"./ArrowIcon.js": 545,
	"./BusinessTargetsDeslected.svg": 976,
	"./CapacityBuildingSidebar.svg": 977,
	"./CapacityDetailsEditIcon.svg": 754,
	"./DownloadSelectedDeliveries.svg": 978,
	"./EPR_Recykal.svg": 444,
	"./EmptyTableIcon": 598,
	"./EmptyTableIcon.jsx": 598,
	"./FetchIcon": 599,
	"./FetchIcon.jsx": 599,
	"./File_Icon_Vendor.svg": 755,
	"./FreeWoQuantityIcon.svg": 756,
	"./FullfillmentTracking.svg": 979,
	"./InfoSquare": 546,
	"./InfoSquare.jsx": 546,
	"./ManavendorsSidebar.svg": 980,
	"./MessageDotsCircle": 365,
	"./MessageDotsCircle.jsx": 365,
	"./PlannedDownloadAllDeliveries.svg": 981,
	"./Recykal_black.svg": 757,
	"./SortAscending.png": 733,
	"./SuccessCheck.svg": 315,
	"./TruckImg.gif": 758,
	"./Union1.png": 734,
	"./UploadFiles.svg": 316,
	"./Upload_Document_vendor.svg": 759,
	"./WorkAreaArrowFatLinesDown.svg": 982,
	"./WorkAreaTarget.svg": 735,
	"./WorkAreaTruck.svg": 736,
	"./WorkOrderFilter.svg": 983,
	"./Work_Area_ ArrowUp.svg": 984,
	"./Work_Area_ArrowDown.svg": 985,
	"./WorkareaSidebar.svg": 986,
	"./_App/calender.svg": 987,
	"./_App/change-password-icon.svg": 988,
	"./_App/checked.svg": 989,
	"./_App/company.svg": 990,
	"./_App/create.svg": 991,
	"./_App/cross.svg": 992,
	"./_App/delivery_success.svg": 495,
	"./_App/docgeneratedimg.png": 496,
	"./_App/driver.svg": 993,
	"./_App/dropoff.svg": 994,
	"./_App/dropsv.svg": 995,
	"./_App/empty.png": 192,
	"./_App/expand_arrow.svg": 996,
	"./_App/eye.svg": 997,
	"./_App/filter.svg": 998,
	"./_App/folder.svg": 999,
	"./_App/ic_delivery.svg": 1000,
	"./_App/ic_home.svg": 1001,
	"./_App/ic_wo.svg": 1002,
	"./_App/in_transit.svg": 1003,
	"./_App/input_form.svg": 1004,
	"./_App/invoicegenerate.svg": 497,
	"./_App/item.svg": 1005,
	"./_App/location.svg": 1006,
	"./_App/location_icon.svg": 1007,
	"./_App/login_truck.svg": 1008,
	"./_App/logout.svg": 1009,
	"./_App/marker.svg": 1010,
	"./_App/noInternet.png": 1011,
	"./_App/notification.svg": 1012,
	"./_App/picksv.svg": 1013,
	"./_App/pickup.svg": 1014,
	"./_App/pickup_qty.svg": 1015,
	"./_App/pickup_truck.svg": 498,
	"./_App/planner.svg": 1016,
	"./_App/profile.svg": 1017,
	"./_App/recykal_logo.png": 1018,
	"./_App/reject.svg": 499,
	"./_App/schedule.svg": 1019,
	"./_App/service.svg": 1020,
	"./_App/sortby.svg": 1021,
	"./_App/source_location .svg": 1022,
	"./_App/supervisor.svg": 1023,
	"./_App/transicon.svg": 1024,
	"./_App/transporter.svg": 1025,
	"./_App/user.svg": 1026,
	"./_App/wall_clock.svg": 1027,
	"./_App/work_order_icon.svg": 1028,
	"./add-icon-blue.svg": 760,
	"./add-icon.svg": 761,
	"./add_icon_white.svg": 443,
	"./alert-triangle.svg": 762,
	"./arrowLeft.svg": 1029,
	"./arrowRight.svg": 1030,
	"./arrowRightSide.svg": 1031,
	"./attachments.svg": 272,
	"./back.png": 130,
	"./brand.png": 493,
	"./brand/logo.svg": 1032,
	"./brand/samsung.png": 1033,
	"./brand/sygnet.svg": 1034,
	"./calendar.svg": 500,
	"./checked.svg": 737,
	"./chevron-left-double.svg": 725,
	"./chevron-right-double.svg": 726,
	"./chevron-right.svg": 763,
	"./close-icon.svg": 440,
	"./collapse-icon.png": 764,
	"./copy.svg": 317,
	"./create-date-icon.svg": 1035,
	"./dashboard.svg": 1036,
	"./date-picker.png": 1037,
	"./datepicker-icon.svg": 1038,
	"./delete-icon.svg": 1039,
	"./delete-outline-icon.svg": 718,
	"./delete.svg": 107,
	"./doc-download.svg": 1040,
	"./dots-vertical.png": 765,
	"./download-blue.svg": 738,
	"./download-cloud.svg": 727,
	"./download.svg": 739,
	"./edit-24px.svg": 1041,
	"./edit-icon-blue-outline.svg": 728,
	"./edit-icon.svg": 740,
	"./edit-outline-icon.svg": 1042,
	"./edit.svg": 1043,
	"./edit_03.svg": 720,
	"./empty-table.svg": 304,
	"./energy.png": 766,
	"./energy.svg": 501,
	"./execution.svg": 1044,
	"./expand-icon.png": 767,
	"./failed.svg": 741,
	"./file.svg": 313,
	"./file_outline.svg": 742,
	"./float-label.svg": 314,
	"./forward.svg": 1045,
	"./goTo.png": 1046,
	"./goto.svg": 1047,
	"./grid.svg": 1048,
	"./ic_menu.svg": 768,
	"./ic_warning.svg": 305,
	"./img_warning.svg": 1049,
	"./inprogress-arrow.gif": 1050,
	"./invoice.svg": 1051,
	"./invoices.svg": 1052,
	"./landfill.png": 769,
	"./landfill.svg": 502,
	"./list.svg": 1053,
	"./location-white.svg": 743,
	"./location.svg": 744,
	"./locations-nav.svg": 1054,
	"./locations-step.svg": 1055,
	"./logo-only.png": 1056,
	"./manage-credits.svg": 1057,
	"./no_data.svg": 717,
	"./notification.svg": 1058,
	"./oil.png": 770,
	"./oil.svg": 503,
	"./order.svg": 1059,
	"./pdf.svg": 1060,
	"./pollutants.png": 771,
	"./pollution.svg": 504,
	"./profile.svg": 1061,
	"./purchase-orders.svg": 1062,
	"./pwp.svg": 1063,
	"./radio-checked.png": 1064,
	"./radio_brand.svg": 1065,
	"./radio_service_provider.svg": 1066,
	"./re-upload-cloud.svg": 745,
	"./re-upload-yellow.svg": 746,
	"./receivable.svg": 1067,
	"./recyclable.png": 1068,
	"./recycler.svg": 1069,
	"./recykal-logo-new.svg": 1070,
	"./recykul-login.png": 469,
	"./refresh.svg": 747,
	"./report.svg": 1071,
	"./report/EPR-loop-white-color.png": 1072,
	"./report/recykal-epr-big-image.png": 1073,
	"./report/recykal-green-logo-new.png": 1074,
	"./report/recykal-logo-white.png": 1075,
	"./report/recykal_green logo.png": 1076,
	"./report/recykl-big-img.png": 772,
	"./roles.svg": 1077,
	"./search-icon-grey.svg": 220,
	"./search.svg": 1078,
	"./server-down.svg": 505,
	"./server_down_s4lk-2.svg": 1079,
	"./service-provider-icon.svg": 1080,
	"./service-provider.png": 494,
	"./service-provider.svg": 1081,
	"./slick-prev.svg": 1082,
	"./special-vendors.svg": 1083,
	"./standard-vendors.svg": 1084,
	"./stepper-active-icon.svg": 773,
	"./stepper-complete-icon.svg": 774,
	"./stepper-inactive-icon.svg": 775,
	"./superadmin.svg": 1085,
	"./sutainability.png": 776,
	"./target.svg": 1086,
	"./target_empty_icon.svg": 239,
	"./target_icon.svg": 188,
	"./tick_icon.svg": 288,
	"./ticksign.png": 166,
	"./trash-icon-red.svg": 721,
	"./trash-outline-red.svg": 777,
	"./trash.svg": 506,
	"./trees.png": 778,
	"./trees.svg": 1087,
	"./under_construction.svg": 226,
	"./undraw_empty_xct9.svg": 1088,
	"./upload-agrement.svg": 1089,
	"./upload-cloud.svg": 748,
	"./upload-document.svg": 1090,
	"./upload-white.svg": 507,
	"./upload.png": 295,
	"./upload.svg": 1091,
	"./upload_doc_gray.svg": 749,
	"./user.svg": 1092,
	"./van.svg": 398,
	"./view-icon.svg": 779,
	"./view-outline-icon.svg": 780,
	"./water.png": 781,
	"./water.svg": 508,
	"./work-order.svg": 1093,
	"./x-circle.svg": 782,
	"./x-close.svg": 750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;